import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/layout/sidebar/lllustrations/saldo_cod.svg'


const _hoisted_1 = {
  key: 0,
  class: "px-3"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-y-1"
}
const _hoisted_3 = { class: "flex items-center gap-x-1" }
const _hoisted_4 = {
  class: "font-medium",
  style: {"font-size":"9px"}
}
const _hoisted_5 = { class: "font-bold text-base" }
const _hoisted_6 = {
  key: 1,
  class: "absolute right-0 top-1/2 transform -translate-y-1/2 z-10 h-full opacity-20"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-full h-full",
  alt: "Sisa saldo cod"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.accountData.account_type_detail && !_ctx.isLoadingBalance && _ctx.visibleSaldo)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _withDirectives(_createVNode("div", {
          class: ["text-white rounded-lg p-1.5 flex items-start gap-x-1 w-full relative cursor-pointer bg-green-lp-100", [{ 'justify-center': _ctx.collapse }]],
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoBalance && _ctx.gotoBalance(...args)))
        }, [
          _createVNode(_component_Icons, {
            name: "wallet-cod",
            class: "w-5"
          }),
          (!_ctx.collapse)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("codIncome.summaryTitle")), 1)
                ]),
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.priceView), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.collapse)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _hoisted_7
              ]))
            : _createCommentVNode("", true)
        ], 2), [
          [_directive_tooltip, _ctx.collapse ? 'Hasil COD' : undefined]
        ])
      ]))
    : _createCommentVNode("", true)
}